<template>
  <div class="agreement-row-actions">
    <el-button
      type="text"
      icon="el-icon-rank"
      class="handle"
      size="mini"
      style="cursor: move;"
    />
    <!--<fa-icon-->
      <!--class="el-button&#45;&#45;text"-->
      <!--name="eye"-->
      <!--style="margin-left: 10px; margin-top: 7px; cursor: pointer;"-->
      <!--@click.native="dialogVisible = true"-->
    <!--/>-->
    <el-button
      type="text"
      icon="el-icon-delete"
      size="mini"
      style="margin-left: 10px;"
      @click="$emit('removeRow')"
    />
    <!--<el-dialog-->
      <!--title="Visibility rules"-->
      <!--:visible.sync="dialogVisible"-->
      <!--width="700px"-->
    <!--&gt;-->
      <!--<div style="display: flex;">-->
        <!--<div>-->
          <!--<el-select v-model="value"-->
            <!--placeholder="Select"-->
            <!--size="small">-->
            <!--<el-option-->
              <!--v-for="item in [{label: 'asd', value: 1}]"-->
              <!--:key="item.value"-->
              <!--:label="item.label"-->
              <!--:value="item.value">-->
            <!--</el-option>-->
          <!--</el-select>-->
        <!--</div>-->
        <!--<div>-->
          <!--<el-select v-model="value"-->
            <!--placeholder="Select"-->
            <!--size="small">-->
            <!--<el-option-->
              <!--v-for="item in [{label: 'asd', value: 1}]"-->
              <!--:key="item.value"-->
              <!--:label="item.label"-->
              <!--:value="item.value">-->
            <!--</el-option>-->
          <!--</el-select>-->
        <!--</div>-->
        <!--<div>-->
          <!--<el-select v-model="value"-->
            <!--placeholder="Select"-->
            <!--size="small">-->
            <!--<el-option-->
              <!--v-for="item in [{label: 'asd', value: 1}]"-->
              <!--:key="item.value"-->
              <!--:label="item.label"-->
              <!--:value="item.value">-->
            <!--</el-option>-->
          <!--</el-select>-->
        <!--</div>-->
      <!--</div>-->
      <!--<span slot="footer"-->
        <!--class="dialog-footer">-->
        <!--<el-button @click="dialogVisible = false">Cancel</el-button>-->
        <!--<el-button type="primary"-->
          <!--@click="dialogVisible = false">Confirm</el-button>-->
      <!--</span>-->
    <!--</el-dialog>-->
  </div>
</template>

<script>
  import Rules from './Rules';

  export default {
    props: ['columnNumbers'],
    data() {
      return {
        dialogVisible: false,
        settingsVisible: false,
        columns: this.columnNumbers,
      };
    },
    components: {
      Rules,
    },
  };
</script>

<style>
  .agreement-builder .agreement-row .agreement-row-actions {
    display: flex;
    position: absolute;
    top: 0;
    right: 0;
    padding: 5px 10px 0 0;
  }
</style>
